#import "../../../../../../../../../../../common/graphql/EntityDocumentsFields.graphql"
query TravelerDetails($id: UUID!) {
  traveler(id: $id) {
    id
    __typename
    _isTripBreakdownAllowed
    _urgencyLevel
    _isUpdatable
    _isAliasInvoked
    _isAliasOriginalNameViewable
    _isUpdateTravelerOverride
    _isDeletable
    _rowTimestamp
    firstName
    _fullName
    companyOrLastName
    userOccupationTitleId
    travelerDepartmentId
    _isStagedApprovalRequest
    _isApprovalRevocable
    _requiredApprovalDocuments
    _isApprovalDocumentsRequired
    isIsleSeatPreferred
    frequentFlyerNumber
    isIsleSeatPreferred
    isWindowSeatPreferred
    isEconomyClassPreferred
    isBusinessClassPreferred
    isFirstClassPreferred
    isCharterClassPreferred
    isPremiumClassPreferred
    isDraft
    statusType {
      statusType
      approvalState
      _transactionIconStatus
    }
    travelerAddressesByTravelerId(orderBy: IS_PRIMARY_DESC) {
      nodes {
        id
        _rowTimestamp
        addressLine1
        addressLine2
        cityName
        countryId
        stateRegionId
        postalCode
        telephoneNumber
        emailAddress
        isGroundTransferAddress
        isDeliveryAddress
        isPrimary
        stateRegion {
          stateRegionDescription
          stateRegion
          country {
            country
          }
        }
        country {
          country
        }
      }
    }
    _travelPolicyAllowances(
      orderBy: TRAVEL_POLICY_EXPENDITURE_TYPE_BY_EXPENDITURE_TYPE_ID__SORT_ORDER_ASC
    ) {
      nodes {
        id
        expenditureType {
          expenditureType
        }
        allowanceOverrideAmount
        _allowanceDescription
        isAllowanceCustomizable
        _travelerPolicyAllowanceRowTimestamp
        _travelerPolicyAllowanceId
      }
    }
    travelerCompanionTickets
    travelerCompanionAmount
    travelerCompanionMasterId
    travelPolicyId
    travelPolicy {
      id
      description
      isContractual
      isCompanion
      isDefaultCustomizable
      companyCurrency {
        isoCode
      }
    }
    travelerDietaryRequirementsByTravelerId(orderBy: [ID_ASC]) {
      nodes {
        id
        description
        _rowTimestamp
        _isDeletable
        dietaryRequirement {
          id
          isDescriptionRequired
        }
      }
    }
    travelerHistoriesByEntityId {
      nodes {
        tenantUserName
        pointInTimeDate
        crudOperation
      }
    }
    entityTagsByEntityId {
      nodes {
        id
        _isDeletable
        _tagBadgeName
        _tagBadgeColor
        _rowTimestamp
      }
    }
    entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      totalCount
      nodes {
        ...EntityDocumentsFields
      }
    }
    nameAlias
    _sortName
    vendorNumber
    _isApproved
    _pickupAddress
    userOccupation {
      userOccupationTitle
    }
    department {
      name
    }
    approvalHistoriesByEntityId {
      nodes {
        id
        requesterName
        requestedDate
        amount1
        currencyIsoCode
        isApprovalTreeViewerAllowed
        iconType {
          iconType
          iconState
        }
        statusType {
          statusType
        }
      }
    }
  }
}
